/** Режим встраивания клуба в iframe на маркетинговом лендинге. */
export function isLandingEmbedMode() {
  if (typeof window === "undefined") return false;
  try {
    return new URLSearchParams(window.location.search).get("landing_embed") === "1";
  } catch {
    return false;
  }
}
